import { useCallback } from 'react'
import { oauthAxiosInstance } from 'services/api/oauthAxiosInstance'
import { OAuthInteractionResponse } from './interfaces/OAuthInteractionResponse'
import { OAuthInteractionParams } from './interfaces/OAuthInteractionParams'
import { OAuthLoginRequest } from './interfaces/OAuthLoginRequest'
import { OAuthOtpRequest } from './interfaces/OAuthOtpRequest'
import { OAuthConsentRequest } from './interfaces/OAuthConsentRequest'

export const useIamManagerOAuth = () => {
  const endpoint = 'oauth'
  const getInteraction = useCallback(
    (id: string) =>
      oauthAxiosInstance.get<OAuthInteractionResponse>(
        `${endpoint}/interactions/${encodeURIComponent(id)}`
      ),
    []
  )
  const login = useCallback(
    ({ id, csrf, ...body }: OAuthLoginRequest) =>
      oauthAxiosInstance.post<OAuthInteractionResponse>(
        `${endpoint}/interactions/${encodeURIComponent(id)}/login`,
        body,
        { headers: { 'X-CSRF-Token': csrf } }
      ),
    []
  )
  const verifyOtp = useCallback(
    ({ id, csrf, ...body }: OAuthOtpRequest) =>
      oauthAxiosInstance.post<OAuthInteractionResponse>(
        `${endpoint}/interactions/${encodeURIComponent(id)}/otp`,
        body,
        { headers: { 'X-CSRF-Token': csrf } }
      ),
    []
  )
  const consent = useCallback(
    ({ id, csrf, ...body }: OAuthConsentRequest) =>
      oauthAxiosInstance.post<{ redirect_uri: string }>(
        `${endpoint}/interactions/${encodeURIComponent(id)}/consent`,
        body,
        { headers: { 'X-CSRF-Token': csrf } }
      ),
    []
  )
  const switchUser = useCallback(
    ({ id, csrf }: OAuthInteractionParams) =>
      oauthAxiosInstance.post<OAuthInteractionResponse>(
        `${endpoint}/interactions/${encodeURIComponent(id)}/switch-user`,
        {},
        { headers: { 'X-CSRF-Token': csrf } }
      ),
    []
  )

  return { endpoint, getInteraction, login, verifyOtp, consent, switchUser }
}
